import * as CryptoJS from "../Lib/crypto-js"
import encryptWays from "./encryptionWay";

class SHORT_BU66_SDK {
    /**
     * 秘钥
     * @var string
     */
    private _apikey = '302631-2212-BDB';
    private _apisecret = 'b46112b9129082e7419f0509de296f95';
    action  = "add";
    private _server = `https://api.bu66.com/api/${this.action}?apikey=${this._apikey}&apisecret=${this._apisecret}`; //服务器地址

    /**
     * 构造函数
     *
     * @param string $apikey
     * @param string $apisecret
     */
    // constructor(apikey, apisecret)
    // {
    //     cc.log("===进入SHORT_BU66_SDK构造");
    //     this._apikey = apikey;
    //     this._apisecret = apisecret;
    // }

    /**
     * API接口调用
     *
     * @param string $action 接口方法
     * @param array $data 数据数组
     * @return array
     */
    api(action, data)
    {
        //let str = this._call(action, data);

        // 写日志

        // if(str == ''){
        //     cc.log("===接口调用失败");
        //     return false;
        // }
        // let ret = JSON.encode(str, true);
        // if(!ret || !isset($ret['result'])){
        //     return array(false, '接口结果解析失败');
        // }
        // if(ret['result'] != 0){
        //     return array(false, $ret['message']);
        // }
        // return array(true, $ret['data']);
    }

    /**
     * 请求网关
     *
     * @param string $action
     * @param array $data
     * @param int $timeout
     * @return string
     */
    sendShortBu66(action, link): Promise<any>{
        return new Promise<any>(resolve => {
            this.action = action;
            let urlStr = this._server
            let data = {"link":link,"info":"subo"};
            let xhr = new XMLHttpRequest()
            xhr.onload = function () {
                if (xhr.status === 200){
                    if (cc.sys.isBrowser) {
                        cc.log('=====短链接收到数据:', xhr.response)
                    }else {
                        cc.log('=====短链接收到数据:', JSON.stringify(xhr.response))
                    }
                    resolve(xhr.response)
                }else{
                    cc.error("请求失败：status=" + xhr.status)
                    resolve(false)
                }
            }
            xhr.onerror = function () {
                cc.error("===请求短链接网络错误")
                resolve(false)
            }
            xhr.timeout = 8000;
            xhr.ontimeout = function (e) {
                cc.error("====sendShortBu66请求超时")
                resolve(false)
            }
            xhr.open('POST', urlStr, true)
            let dataJson = JSON.stringify(data);
            xhr.send(dataJson)
        })

    }

}
export default new SHORT_BU66_SDK()
